var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import screenfull from 'screenfull';
import { action, observable, makeObservable } from 'mobx';
export class BrowserFullscreen {
    parent;
    fullscreenElement = document.fullscreenElement;
    numberOfFullscreenErrors = 0;
    get browserRuntime() {
        return this.parent;
    }
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
        document.addEventListener('fullscreenerror', this.handleFullscreenError);
        if (screenfull.isEnabled) {
            screenfull.on('change', this.handleFullscreenChange);
        }
        // document.addEventListener('fullscreenchange', this.handleFullscreenChange);
        document.addEventListener('mozfullscreenchange', this.handleFullscreenChange);
        document.addEventListener('webkitfullscreenchange', this.handleFullscreenChange);
        document.addEventListener('msfullscreenchange', this.handleFullscreenChange);
    }
    get isInFullscreen() {
        return !!this.fullscreenElement;
    }
    handleFullscreenError(e) {
        console.error(e);
        if (this.isInFullscreen)
            return;
        this.numberOfFullscreenErrors++;
        if (this.numberOfFullscreenErrors > 1)
            return;
        this.browserRuntime.app.message.warning('Vollbildmodus nicht verfügbar.');
    }
    handleFullscreenChange(e) {
        this.fullscreenElement = document.fullscreenElement;
    }
    get shouldTriggerFullscreen() {
        return (this.browserRuntime &&
            !this.isInFullscreen &&
            this.browserRuntime.browserDevice.isTabletOrSmartphone &&
            !this.browserRuntime.app.appInfo.isMobileAppWebView);
    }
    requestFullScreen() {
        if (this.isInFullscreen)
            return;
        if (this.browserRuntime.app.appInfo.isMobileAppWebView)
            return;
        if (this.browserRuntime.browserAgent.isSafari)
            return; // Input fields currently not possible in Safari Fullscreen Mode
        if (screenfull.isEnabled) {
            screenfull.request();
        }
        else {
            // Ignore or do something else
        }
        /*
        const el = document.documentElement;
        if (!el) return;
    
        if (el.requestFullscreen) {
          try {
            el.requestFullscreen();
          } catch (e) {
            console.warn(e);
          }
    
          return;
        } */
        /*
        if (el.webkitEnterFullScreen) {
          el.webkitEnterFullScreen();
          return;
        }
    */
        //  if (el.webkitRequestFullscreen) el.webkitRequestFullscreen(); // (Element as any).ALLOW_KEYBOARD_INPUT
        //  if (el.mozRequestFullScreen) el.mozRequestFullScreen();
        //  if (el.msRequestFullscreen) el.msRequestFullscreen();
    }
    exitFullScreen() {
        if (screenfull.isEnabled) {
            screenfull.exit();
        }
    }
}
__decorate([
    observable.ref
], BrowserFullscreen.prototype, "fullscreenElement", void 0);
__decorate([
    action.bound
], BrowserFullscreen.prototype, "handleFullscreenError", null);
__decorate([
    action.bound
], BrowserFullscreen.prototype, "handleFullscreenChange", null);
__decorate([
    action.bound
], BrowserFullscreen.prototype, "requestFullScreen", null);
__decorate([
    action.bound
], BrowserFullscreen.prototype, "exitFullScreen", null);
